import React from 'react';
import moment from 'moment';
import type { TimeframeSelection } from '../../types/timeframe';
import DatepickerTrigger from './DatepickerTrigger';

interface TimeframeFilterProps {
  /** The last committed (applied) timeframe selection. */
  value: TimeframeSelection;
  /** Called when the user clicks APPLY with a changed selection. */
  onChange: (selection: TimeframeSelection) => void;
}

/**
 * Advanced datepicker for the Usage Reporting dashboard.
 *
 * Collapsed state: a pill-shaped trigger showing granularity badge + date range.
 * Expanded state: a 4-column panel (Aggregate By | Date Range | Start Month | End Month)
 * with Apply / Cancel buttons.
 */
const TimeframeFilter: React.FC<TimeframeFilterProps> = ({ value, onChange }) => (
  <DatepickerTrigger value={value} onChange={onChange} maxDate={moment().subtract(2, 'days')} />
);

export default TimeframeFilter;
